export default {
  path: '/qianchuan/selfop',
  name: 'selfop',
  component: resolve => require(['@/views/selfop'], resolve),
  meta: {
    keepAlive: true,
    title: '智运营',
    sidebar: false,
    permission: 'operation:rule',
    activeName: '/selfop',
    name: 'selfop'
  },
  children: [
    {
      path: 'main',
      name: 'qcmain',
      component: resolve => require(['@/views/selfop/main'], resolve),
      meta: {
        keepAlive: true,
        title: '智运营',
        iconName: 'icon-xiansuo-daoyinxuanzhong',
        permission: 'operation:rule'
      },
      subMenu: [
        {
          name: 'qcrule',
          title: '规则管理'
        }
      ],
      children: [
        {
          path: 'qcrule',
          name: 'qcrule',
          component: resolve => require(['@/views/selfop/rule'], resolve),
          meta: {
            keepAlive: true,
            title: '规则管理',
            iconName: 'icon-xiansuo-daoyinxuanzhong',
            parents: 'main',
            permission: 'operation:rule:list'
          },
          children: [
            {
              path: 'newRules',
              name: 'qcnewRules',
              component: resolve => require(['@/views/selfop/rule/newRules'], resolve),
              meta: {
                keepAlive: true,
                title: '新建规则'
              }
            }
          ]
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/qianchuan/selfop.js